/**
 * @fileoverview Zod schemas and types for Cost of Sold Goods feature.
 * @module features/cogs/schemas/costOfSoldGoodsSchema
 */

import { z } from 'zod'

/**
 * Month string in MM-yyyy format, validated strictly.
 * Examples: "01-2025", "12-2024"
 */
export const MonthStringSchema = z
  .string()
  .regex(/^(0[1-9]|1[0-2])-\d{4}$/, 'Month must be in MM-yyyy format')

/**
 * Single cost-of-sold-goods line item.
 */
export const CostOfSoldGoodsItemSchema = z.object({
  sku: z.string(),
  unitsSold: z.number(),
  costPerSKU: z.number(),
  totalCost: z.number(),
  productName: z.string().nullable().optional(),
  imageUrl: z.string().nullable().optional(),
})

/**
 * API response for cost-of-sold-goods.
 */
export const CostOfSoldGoodsResponseSchema = z.object({
  items: z.array(CostOfSoldGoodsItemSchema),
  totalCost: z.number(),
  currencyCode: z.string().regex(/^[A-Z]{3}$/u, 'currencyCode must be a 3-letter ISO 4217 code'),
})

/**
 * API request params for cost-of-sold-goods.
 */
export const CostOfSoldGoodsParamsSchema = z.object({
  month: MonthStringSchema,
})

export type CostOfSoldGoodsItemDTO = z.infer<typeof CostOfSoldGoodsItemSchema>
export type CostOfSoldGoodsResponseDTO = z.infer<typeof CostOfSoldGoodsResponseSchema>
export type CostOfSoldGoodsParams = z.infer<typeof CostOfSoldGoodsParamsSchema>
